import React from 'react';
import Loading from './Loading';

const ResponsiveMatchUser = ({ voter,onsubmit,buttonState }) => {
  return (
    <div className={`border border-[#EAEDF2] w-full`}>
        <div className="xs:flex xs:justify-end xs:items-center bg-[#e5e7eb] p-2">
            <button
                onClick={onsubmit}
                className="text-[16px] font-medium leading-[26px] tracking-normal font-mont text-[#D30039] block xs:ml-0 ml-auto xs:mt-0 mt-[5px]"
            >
                {buttonState === "loading" ? <>
                    <div>
                        <Loading size={18} />
                    </div>
                    </> : 'SUBMIT'
                    }
            </button>
        </div>

        <div>
            <div className={`flex justify-between xxs:p-[9.5px] p-[8px] items-center`}>
                <span className="text-[16px] font-medium leading-[26px] tracking-normal font-mont">Voter ID</span>
                <span className="text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack max-w-[180px] text-right">{voter.voter_id}</span>
            </div>
            <div className={`flex justify-between xxs:p-[9.5px] p-[8px] items-center`}>
                <span className="text-[16px] font-medium leading-[26px] tracking-normal font-mont">Full Name</span>
                <span className="text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack max-w-[180px] text-right">{voter.first_name} {voter.middle_name} {voter.last_name}</span>
            </div>
            <div className={`flex justify-between xxs:p-[9.5px] p-[8px] items-center`}>
                <span className="text-[16px] font-medium leading-[26px] tracking-normal font-mont">Full Address</span>
                <span className="text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack max-w-[180px] text-right">{voter.full_address}</span>
            </div>
        </div>
    </div>
  );
};

export default ResponsiveMatchUser;